import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import SelectBox from 'components/SelectBox';

interface IProps {
  data: any;
  value: any;
  handleOnChangeSelect: (value: any, type: string) => void;
}

const UnlockStyleSelect: React.FC<IProps> = ({
  data,
  value,
  handleOnChangeSelect,
}) => {
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  return (
    <SelectBox
      value={selectedValue}
      onChange={(e) => {
        handleOnChangeSelect(e, 'unlock_by');
      }}
      options={data?.map((e) => {
        return {
          value: e.code,
          label: e.code_name,
        };
      })}
    />
  );
};

export default UnlockStyleSelect;
